import ApiService from '@/helpers/api.service.ext';

const API = new ApiService();

const ENDPOINT = 'dashboards/kankolek';

export const state = {
  kankolekWidgets: {
    activeUser:{
      current: 0,
      previous: 0
    },
    transactionCount:{
      current: 0,
      previous: 0
    },
    transactionValue:{
      current: 0,
      previous: 0
    },
    peddlrShare:{
      current: 0,
      previous: 0
    },
    totalP2P: {
        current: 0,
        previous: 0
    },
    totalP2M: {
        current: 0,
        previous: 0
    }
  },
  kankolekTransactions:[],
  kankolekTotalTransactions:0,
  errors: null,
  kankolekDashboardSummary: {
    "currentMonth": {
      "total_incoming": 0,
      "total_incoming_mdr": 0,
      "total_incoming_mdr_netbank_share": 0,
      "total_incoming_kolek_fee": 0,
      "total_incoming_kf_netbank_share": 0,
      "total_incoming_merchant_share": 0,
      "total_incoming_convenience_fee": 0,
      "total_outgoing": 0,
      "total_outgoing_transfer_fee": 0,
      "total_outgoing_netbank_share": 0,
      "total_eload_sc": 0,
      "cm_one": 0,
      "cm_two": 0,
      "gross_total_value": 0,
      "revenue": 0,
      "total_deductions": 0,
      "prev_incoming_mdr_netbank_share": 0,
      "prev_incoming_kf_netbank_share": 0,
      "prev_outgoing_netbank_share": 0,
      "gtv_cm_two_percentage": 0,
      "rev_cm_two_percentage": 0
    },
    "previousMonth": {
      "total_incoming": 0,
      "total_incoming_mdr": 0,
      "total_incoming_mdr_netbank_share": 0,
      "total_incoming_kolek_fee": 0,
      "total_incoming_kf_netbank_share": 0,
      "total_incoming_merchant_share": 0,
      "total_incoming_convenience_fee": 0,
      "total_outgoing": 0,
      "total_outgoing_transfer_fee": 0,
      "total_outgoing_netbank_share": 0,
      "total_eload_sc": 0,
      "cm_one": 0,
      "cm_two": 0,
      "gross_total_value": 0,
      "revenue": 0,
      "total_deductions": 0,
      "prev_incoming_mdr_netbank_share": 0,
      "prev_incoming_kf_netbank_share": 0,
      "prev_outgoing_netbank_share": 0,
      "gtv_cm_two_percentage": 0,
      "rev_cm_two_percentage": 0
    },
    "pmtd": {
      "total_incoming": 0,
      "total_incoming_mdr": 0,
      "total_incoming_mdr_netbank_share": 0,
      "total_incoming_kolek_fee": 0,
      "total_incoming_kf_netbank_share": 0,
      "total_incoming_merchant_share": 0,
      "total_incoming_convenience_fee": 0,
      "total_outgoing": 0,
      "total_outgoing_transfer_fee": 0,
      "total_outgoing_netbank_share": 0,
      "total_eload_sc": 0,
      "cm_one": 0,
      "cm_two": 0,
      "gross_total_value": 0,
      "revenue": 0,
      "total_deductions": 0,
      "prev_incoming_mdr_netbank_share": 0,
      "prev_incoming_kf_netbank_share": 0,
      "prev_outgoing_netbank_share": 0,
      "gtv_cm_two_percentage": 0,
      "rev_cm_two_percentage": 0
    }
  },
  kankolekActiveUsers: {
    "pm_active_user_kf": 0,
    "pmtd_active_user_kf": 0,
    "current_active_user_kf": 0,
    "pm_active_user_mdr": 1,
    "pmtd_active_user_mdr": 0,
    "current_active_user_mdr": 0,
    "pm_active_user_transfer": 1,
    "pmtd_active_user_transfer": 0,
    "current_active_user_transfer": 0,
    "pm_active_user_total": 2,
    "pmtd_active_user_total": 0,
    "current_active_user_total": 0
  }
}

export const mutations = {
  SET_ERROR(state, errors){
    state.errors = errors;
  },
  UPDATE_KANKOLEK_WIDGETS(state, status){
    state.kankolekWidgets = status;
  },
  UPDATE_KANKOLEK_TRANSACTION(state, data){
    state.kankolekTransactions = data;
  },
  UPDATE_KANKOLEK_TOTAL_TRANSACTION(state, data){
    state.kankolekTotalTransactions = data;
  },
  UPDATE_KANKOLEK_SUMMARY(state, data){
    state.kankolekDashboardSummary = data;
  },
  UPDATE_KANKOLEK_ACTIVE_USERS(state, data){
    state.kankolekActiveUsers = data?.activeUser;
  }
}

export const actions = {
  actionDashboardKankolek(context, params) {
    return new Promise((resolve, reject) => {
      API.post(`/${ENDPOINT}/${params.action}`, params.body)
        .then(({ data }) => {
          if (data.status === "ok") {
            resolve(data)
          } else {
            reject(data.message)
          }
          switch (params.action) {
            case "widgets":
              context.commit('UPDATE_KANKOLEK_WIDGETS', data.message);
              break;
            case "list":
              context.commit('UPDATE_KANKOLEK_TRANSACTION', data.message.rows);
              context.commit('UPDATE_KANKOLEK_TOTAL_TRANSACTION', data.message.pageInfo.total);
              break;
            case "summary":
              context.commit('UPDATE_KANKOLEK_SUMMARY', data.message);
              break;
            case "active-users":
              context.commit('UPDATE_KANKOLEK_ACTIVE_USERS', data.message);
              break;
            default:
              break;
          }
        })
        .catch(({ response }) => {
          context.commit('SET_ERROR', response.data.errors);
          reject();
        });
    });
  }
}

export const getters = {}